export default __webpack_public_path__ + "static/media/supper_apps_background_s1.5742a801.jpg";